import { OrganizationScopePicker } from "@/modules/dashboard/payments-config/components/OrganizationScopePicker";
import { useOrganizationsCatalog } from "@/modules/dashboard/payments-config/hooks/useOrganizationsCatalog";
import useTranslations from "@/shared/lang/useTranslations";

export interface CryptoSwapOrganizationPickerProps {
  id: string;
  value: string | null;
  onValueChange: (organizationId: string | null) => void;
  /** `required` for a form (one organization operates); `scope` for the history filter. */
  mode: "required" | "scope";
  /** The form's own wording of what the picked organization is for. */
  requiredHint?: string;
  orgHint?: string;
}

/** Staff only. Its own component so the organizations catalog is requested only when it renders. */
export function CryptoSwapOrganizationPicker({
  id,
  value,
  onValueChange,
  mode,
  requiredHint,
  orgHint,
}: CryptoSwapOrganizationPickerProps) {
  const { t } = useTranslations("cryptoSwaps");
  const catalog = useOrganizationsCatalog();

  return (
    <OrganizationScopePicker
      id={id}
      mode={mode}
      value={value}
      onValueChange={onValueChange}
      catalog={catalog}
      labels={{
        label: t("org_picker_label"),
        placeholder: t("org_picker_placeholder"),
        loading: t("org_picker_loading"),
        empty: t("org_picker_empty"),
        searching: t("org_picker_searching"),
        searchError: t("org_picker_search_error"),
        catalogError: t("org_picker_catalog_error"),
        catalogTruncated: t("org_picker_catalog_truncated"),
        requiredHint: requiredHint ?? t("org_picker_required_hint"),
        globalOption: t("org_picker_global_option"),
        globalHint: t("org_picker_global_hint"),
        orgHint: orgHint ?? (mode === "required" ? t("org_picker_org_hint") : t("org_picker_filter_hint")),
      }}
    />
  );
}
